// extracted by mini-css-extract-plugin
module.exports = {"settingsBlock":"styles_settingsBlock__Dw44X"};